export default __webpack_public_path__ + "304638ae08c9125091c8d3990ee3c54e.png";